var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_39919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.645 5.67664C18.0856 5.23616 18.3332 4.63869 18.3332 4.01568C18.3333 3.39267 18.0859 2.79515 17.6454 2.35456C17.2049 1.91396 16.6075 1.6664 15.9845 1.66632C15.3615 1.66624 14.7639 1.91366 14.3233 2.35414L3.20167 13.4783C3.00819 13.6712 2.8651 13.9087 2.785 14.17L1.68417 17.7966C1.66263 17.8687 1.66101 17.9453 1.67946 18.0182C1.69792 18.0911 1.73577 18.1577 1.789 18.2108C1.84223 18.264 1.90885 18.3017 1.9818 18.32C2.05475 18.3384 2.1313 18.3366 2.20334 18.315L5.83084 17.215C6.09181 17.1356 6.32932 16.9934 6.5225 16.8008L17.645 5.67664Z",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.16669L15.8333 7.50002",
    stroke: "#171818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_39919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.58ceff08d76a8047735f10cb949235f2.svg";
export { ForwardRef as ReactComponent };